import { render, staticRenderFns } from "./PastScriptDetails.vue?vue&type=template&id=43881f23"
import script from "./PastScriptDetails.vue?vue&type=script&lang=js"
export * from "./PastScriptDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports